import React from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { FileIconButton } from "../../../components/Buttons";
import {
  scrollToTop,
  TableEmptyMessage,
  toUIDate,
} from "../../../components/Utils";
import TablePageReport from "../../../components/TablePageReport";

import { connect } from "react-redux";
import { frontloadConnect } from "react-frontload";
import {
  loadNewsArchives,
  searchNewsArchives,
  loadNewsMessage,
} from "../actions";

const getFilterValues = (props, current) => {
  let values = {
    // first: 0,
    // rows: props.rows || 10,
    keyword: null,
    fromDate: null,
    toDate: null,
    // sortFields: {}
  };
  if (current) {
    values = { ...values, ...current };
  }
  return values;
};

const frontload = async (props) => {
  const filter = getFilterValues(props);
  await props.getNewsArchive({ filter });
};
const mapStateToProps = (state) => {
  return {
    isLoading: state.news.loading,
    archives: state.news.archives,
    filter: state.news.archiveFilter,
  };
};
const mapDispatchToProps = (dispatch) => ({
  getNewsArchive: (...args) => dispatch(loadNewsArchives(...args)),
  searchArchives: (...args) => dispatch(searchNewsArchives(...args)),
  getNewsMessage: (...args) => dispatch(loadNewsMessage(...args)),
});

function NewsArchiveTable({
  isLoading,
  archives,
  filter,
  getNewsArchive,
  getNewsMessage,
  rows = 10,
  className = "",
}) {
  const [first, setFirst] = React.useState(0);
  const prevFilterRef = React.useRef(filter);
  React.useEffect(() => {
    scrollToTop();
    if (JSON.stringify(filter) !== JSON.stringify(prevFilterRef.current)) {
      prevFilterRef.current = filter;
      getNewsArchive({ filter });
    }
  });

  const onPage = (event) => setFirst(event.first);
  const onShowMessage = (newsItem) => {
    getNewsMessage(newsItem);
  };
  const actionTemplate = (rowData) => (
    <div>
      <FileIconButton
        className="pad-sm"
        onClick={() => onShowMessage(rowData)}
      />
    </div>
  );

  if (!archives) {
    return null;
  }
  const data = (archives || []).map((newsItem, index) => ({
    ...newsItem,
    index,
    roles: newsItem.roles,
    title: `${newsItem.titlePrefix || ""} ${newsItem.title || "Meldung"}`,
    sendDate: toUIDate(
      newsItem.sent_date ||
        newsItem.sendDate ||
        newsItem.send_date ||
        newsItem.created_date,
    ),
  }));

  return (
    <div className={`news-table clearfix ${className}`}>
      <DataTable
        value={data}
        rows={rows}
        paginator={data.length > rows}
        first={first}
        onPage={onPage}
        paginatorLeft={
          <TablePageReport
            className="pad-lft"
            totalRecords={data.length}
            filteredRecords={data.length}
            first={first}
            rows={rows}
            emptyText="Keine Nachrichten"
            itemName="Nachricht"
            itemNamePlural="Nachrichten"
          />
        }
        removableSort
        sortMode="multiple"
        emptyMessage={
          isLoading ? null : (
            <TableEmptyMessage itemNamePlural="Nachrichten" />
          )
        }
      >
        <Column
          field="title"
          header="Betreff"
          sortable={data.length > 1}
          filter={data.length > rows}
          filterMatchMode="contains"
        />
        <Column
          field="sendDate"
          header="Versandt am"
          className="alg-center"
          sortable={data.length > 1}
          filter={data.length > rows}
          filterMatchMode="contains"
          style={{ width: "12em" }}
        />
        <Column
          body={actionTemplate}
          className="alg-center"
          style={{ width: "6em" }}
        />
      </DataTable>
    </div>
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(
  frontloadConnect(frontload, {
    onMount: true,
    onUpdate: false,
  })(NewsArchiveTable),
);
